import React from "react";
import "./customToast.css";
import { NOTIFY_ERROR, NOTIFY_SUCCESS, NOTIFY_WARNING } from "../../../types";
import {
  CloseIcon,
  ErrorIcon,
  SuccessIcon,
  WarningIcon,
} from "../../../assets";

const ToastIcon = ({ type }) => {
  switch (type) {
    case NOTIFY_ERROR:
      return <ErrorIcon width={19} height={19} />;
    case NOTIFY_SUCCESS:
      return <SuccessIcon width={19} height={19} />;
    case NOTIFY_WARNING:
      return <WarningIcon width={19} height={19} />;

    default:
      return "info";
  }
};

const getErrorTitle = (type) => {
  switch (type) {
    case NOTIFY_ERROR:
      return "Error";
    case NOTIFY_SUCCESS:
      return "Success";
    case NOTIFY_WARNING:
      return "Warning";
    default:
      return "Info";
  }
};

const CustomToast = ({ payload, type, closeToast }) => {
  return (
    <div className="custom-toast-main-container">
      <div className="custom-toast-title-container">
        <div className="custom-toast-type-icon-box">
          <ToastIcon type={type} />
        </div>
        <div className="custom-toast-title-box">{getErrorTitle(type)}</div>
        <div onClick={closeToast} className="custom-toast-close-icon-box">
          <CloseIcon />
        </div>
      </div>
      <div className="custom-toast-payload">
        <div />
        <div>
          {type === NOTIFY_ERROR ? payload.replaceAll("\\\\", "\\") : payload}
        </div>
        <div />
      </div>
    </div>
  );
};

export default CustomToast;



// WEBPACK FOOTER //
// ./src/components/common/CusomToast/CustomToast.jsx